import { type ReactNode } from 'react';

import { parseClassnames } from '@incloodsolutions/react-toolkit';

interface IStatusPillComponentProps {
	tone?: 'neutral' | 'open' | 'warn' | 'brand';
	className?: string;
	children: ReactNode;
}

/** A small rounded status label with a dot, coloured by tone. */
export function StatusPillComponent({
	tone = 'neutral',
	className,
	children,
}: IStatusPillComponentProps) {
	return (
		<span
			className={parseClassnames(
				'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs leading-none font-semibold',
				{
					'bg-brand-soft text-mute': tone === 'neutral',
					'bg-open-soft text-open': tone === 'open',
					'bg-warn-soft text-warn': tone === 'warn',
					'bg-brand text-on-brand': tone === 'brand',
				},
				className,
			)}
		>
			<span aria-hidden="true" className="size-1.5 rounded-full bg-current" />
			{children}
		</span>
	);
}
